import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';

// Components
import InventoryItemTableEdit from "./InventoryItemTableEdit";
import PurchaseAddItem from "../Purchases/PurchaseAddItem";
import LoadingModal from "../../components/Modal/LoadingModal";

//React Router (for getting parameters)
import {  useParams, useHistory } from "react-router-dom";

//number format plugin
import numeral from "numeral";

//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import { NavLink } from "react-router-dom";

import MessageBox from "../../components/MessageBox/MessageBox";

//cookies
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
import Preloader from "../../components/Preloader/Preloader";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #59b259",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#c1c3d8",
		display:"none"
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(89, 178, 89, 0.09)",
		padding: "1rem",
		border: "1.5px solid #59b259",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #59b259",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	root: {
		color: "#fff",
		backgroundColor: "#4caf50",
		'&:hover': {
		  backgroundColor: "#fff",
		  color: "#4caf50",
		}
	 },
});

const InventoryAdjustmentInformation = () => {
	const x = 0;
	const { warehouseid, type, trandate} = useParams();
	const [supplier, setSupplier] = useState([]);
	const [warehouse, setWarehouse] = useState(null);
	const classes = useStyles();

	const [items, setItems] = useState([]); //data to display in PO table
	const [supplierItem, setSupplierItem] = useState(null); //data to display in Add Item dropdown
	
	const [notes, setNotes] = useState('');

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	//state for managing loading modal
	const [showModal, setShowModal] = useState(false);

	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(true);
		const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));

	let history = useHistory();

	//modified for inventory adjustment
	const addItem = (item) => {
		let found = items.some(x => x.item_id === item.item_id);
		if(found){
			//if item is existing in itemArray, add the qty instead
			let newItems = items.map((it)=> {
				if(it.item_id === item.item_id){ //add
					it.qty += item.qty;
			  	}
			  return it;
			});
			setItems(newItems);
		}else{
			//add new unique item to array
			setItems([...items, 
				{
				item_id: item.id, 
				qty: item.qty,
				uomDesc: item.uomDesc,
				item_name: item.itemname
				}
			]);
		}	
	}

	const deleteItem = (item_id) => {
		//console.log(item_id);
		let itemArray = items.filter(item => item.item_id !== item_id);
		setItems(itemArray);
	}

	const ColorButton = withStyles(() => ({
		root: {
		  color: "#fff",
		  backgroundColor: "#4caf50",
		  '&:hover': {
			backgroundColor: "#fff",
			color: "#4caf50",
		  }
		},
	  }))(Button);

	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
			//console.log('refresh sir');
	}, []);

	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	//update PO total when items update
	useEffect(() => {
		if(items.length > 0) {
			setBtnDisabled(false); // re-enable
		}else{
			setBtnDisabled(true); // re-enable	
		}
	}, [items]);


	const data = async () => {

		await axios.get(process.env.REACT_APP_API_URL+'get_single_warehouse_data', {
			params:{
				warehouse_id: warehouseid,  //supplier_id
			}
		}).then((res)=>{
			setWarehouse(res.data.data);
			console.log('12',res.data.data)
		}).catch((error)=>{
			console.log(error.message)
		});
		await axios.get(process.env.REACT_APP_API_URL+'get_items_for_dropdown', {

			params: {
				branchIdNo
			     }
		}).then((res)=>{
			setSupplierItem(res.data.data);
		}).catch((error)=>{
			console.log(error.message)
		});

	};	

	const save_inv_adj = async () => {
		setBtnDisabled(true); // disable button to avoid multiple saves
		setShowModal(true); //show loading/please wait modal
		const formData = new FormData();
		formData.append("item_array", JSON.stringify(items));
		formData.append("jc_uname", get_cookies('username'));
		formData.append("jc_u_idno", get_cookies('branchidno'));
		formData.append("trandate", trandate);
		formData.append("location", warehouseid);
		formData.append("type", type);
		formData.append("notes", notes);

		await axios.post(process.env.REACT_APP_API_URL+'save_inv_adjustment', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
				}
			}).then(function (res) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("Added new Inventory Transfer");
				setMsgType("success");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
					history.push('/inventory/inventory-adjustment');
				}, 2000)
		  	}).catch(function (error) {
				setShowModal(false); //hide loading/please wait modal 
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
	  		});
	}

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				{/* <NavLink to={"/inventory"}><h4 style={{color:"#339933"}}>Purchases</h4></NavLink> */}
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<NavLink to={"/inventory/inventory-adjustment"}><h4 style={{color:"#339933"}}>Inventory Adjustment</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Inventory Adjustment Information</h4>
			</div>
		{warehouse && supplierItem ? (			<div className="page-container">
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={12}>
								<div className={classes.subTitle}>
									Inventory Adjustment
								</div>
								<div className={classes.title}>
									{"Inventory Adjustment Information"}
								</div>
							</Grid>
								<div style={{marginRight: "0.5em"}}></div>
								<PurchaseAddItem addItem={addItem} supplierItem={supplierItem}/>
								<LoadingModal showModal={showModal}/>
		


					  </Grid>
					</div>
					<CardContent>
						<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Date of Transfer: 
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{trandate || ""}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Location
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{warehouse[0].description || "Location"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Type
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{/* if plus = positive adj, if negative, Negative Adjustment */}
									{type === 'plus' ? 'Positive Adjustment' : 'Negative Adjustment'}
								</Grid>
							</Grid>
						</div>
						<InventoryItemTableEdit items={items} setItems={setItems} deleteItem={deleteItem}/>
						<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							value={notes || ''}
							className={classes.textarea}
							onChange={(e)=>{setNotes(e.target.value)}}
						/>
					</CardContent>
				</Card>
				<div className={classes.buttonContainer}>
					{/* <Button variant="contained">Back</Button> */}
					<ColorButton disabled={btnDisabled} variant="contained" color="primary" onClick={save_inv_adj} classes={{
    					root: classes.root, 
        				disabled: classes.disabled}}>
						Save
					</ColorButton>
				</div>
			</div>
		) : (<Preloader/>)}

		</div>
	);
};

export default InventoryAdjustmentInformation;
